"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMitek = void 0;
const useMitekBase_1 = require("./useMitekBase");
const init_1 = require("../../mobileConnector/init");
const useMitek = () => {
    return (0, useMitekBase_1.useMitekBase)(init_1.mobileConnector);
};
exports.useMitek = useMitek;
//# sourceMappingURL=useMitek.js.map